
function ensureAbsoluteUrl(url){
    if(!url) return url;
    try{
      const u = new URL(url);
      return u.href;
    }catch(e){
      return process.env.REACT_APP_FTP_URL + "/" + (url.startsWith("/") ? url.slice(1) : url);
    }
  }

  function getExtension(url){
    if(!url) return "";
    const clean = url.split("?")[0].split("#")[0];
    const idx = clean.lastIndexOf(".");
    if(idx === -1) return "";
    return clean.slice(idx + 1).toLowerCase();
  }

  function isImageUrl(url){
    const ext = getExtension(url);
    const imageExts = ["png","jpg","jpeg","gif","webp","bmp","svg","tiff","avif","jfif"];
    return imageExts.includes(ext);
  }

  function isVideoUrl(url){
    const ext = getExtension(url);
    const videoExts = ["mp4","webm","ogg","ogv","mov","m4v","mkv"];
    return videoExts.includes(ext);
  }

 export function resolveSlide(slide){
    if(slide?.media?.contentUrl){
      const src = (process.env.REACT_APP_SERVER_URL || "") + slide.media.contentUrl;
      return { type: "image", src };
    }

    if(slide?.urlPhoto){
      const photoSrc = ensureAbsoluteUrl(slide.urlPhoto);
      if(isImageUrl(photoSrc)){
        return { type: "image", src: photoSrc };
      }
      return { type: "iframe", src: photoSrc };
    }

    if(slide?.urlVideo){
      const videoSrc = ensureAbsoluteUrl(slide.urlVideo);
      if(isVideoUrl(videoSrc)){
        return { type: "video", src: videoSrc };
      }
      return { type: "iframe", src: videoSrc };
    }

    return { type: "image", src: "img/temp.png" };
}